import RestRequestFactory from '@core/utils/network/RestRequestFactory';
import SpecialsRequest from '@core/services/specials/_private/SpecialsRequest';
import ServerConfig from '@core/models/country/ServerConfig';

export default class RestService {
    private readonly request: any;

    constructor(config: ServerConfig, restRequestFactory = RestRequestFactory) {
        this.request = restRequestFactory.create(config.offer.hostServer);
    }

    public getSpecialsResults(startDate: Date, endDate: Date): Promise<any> {
        return this.request({
            url: '/offer/getSpecialsOfferByDate',
            method: 'get',
            params: SpecialsRequest.createSpecialsResultsRequest(startDate, endDate)
        });
    }

    public getEvents(specialIds: number[]): Promise<any> {
        return this.request({
            url: '/specials/getSpecialsById',
            method: 'get',
            params: SpecialsRequest.createSpecialsDetailsRequest(specialIds)
        });
    }

    public getSpecialOffer(startDate: Date, endDate: Date): Promise<any> {
        return this.request({
            url: '/offer/getSpecialsOfferByDate',
            method: 'get',
            params: SpecialsRequest.createSpecialOfferRequest(startDate, endDate)
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/specials/_private/RestService.ts